import "./OurValues.css";
import "./theme.css";
import { useEffect } from "react";
import {
  FiShield,
  FiCheckCircle,
  FiZap,
  FiSettings,
  FiUsers,
  FiTrendingUp,
  FiUserCheck,
} from "react-icons/fi";

export default function OurValues() {
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const values = [
    {
      title: "Safety First",
      text: "We place the protection of people, assets, and environments at the core of every solution we build.",
      image: "/safety1.jpg",
      icon: <FiShield />,
    },
    {
      title: "Integrity & Accountability",
      text: "We operate with honesty, transparency, and responsibility — earning trust through consistent actions.",
      image: "/safety4.jpg",
      icon: <FiCheckCircle />,
    },
    {
      title: "Innovation with Purpose",
      text: "We apply technology thoughtfully to solve real industrial safety challenges.",
      image: "/safety6.jpg",
      icon: <FiZap />,
    },
    {
      title: "Reliability & Precision",
      text: "Our platforms are designed to be accurate, dependable, and resilient in critical environments.",
      image: "/safety8.jpg",
      icon: <FiSettings />,
    },
    {
      title: "Customer-Centricity",
      text: "We collaborate closely with our customers to deliver solutions that solve real problems and create measurable impact.",
      image: "/safety10.jpg",
      icon: <FiUsers />,
    },
    {
      title: "Continuous Improvement",
      text: "We constantly learn, adapt, and evolve to stay ahead of emerging risks and industry challenges.",
      image: "/safety11.jpg",
      icon: <FiTrendingUp />,
    },
    {
      title: "Collaboration & Empowerment",
      text: "We believe strong teamwork and empowered people create safer workplaces and sustainable success.",
      image: "/safety7.jpg",
      icon: <FiUserCheck />,
    },
  ];

  return (
    <section className="values-section" aria-label="Our Values">
      <div className="values-bg" />
      <div className="values-arc values-arc-one" />
      <div className="values-arc values-arc-two" />
      <div className="values-bubble values-bubble-one" />
      <div className="values-bubble values-bubble-two" />
      <div className="values-floor" />

      <div className="values-shell">
        <header className="values-header">
          <div className="values-eyebrow">OUR VALUES</div>

          <h2>
            What <span>Guides Us</span>
          </h2>

          <p>
            These values shape our culture, <strong>guide</strong> our
            decisions, and define how we work with our clients and partners to
            create safer, more resilient industries.
          </p>

          <div className="values-heading-line">
            <span />
            <span />
          </div>
        </header>

        <div className="values-pillars">
          {values.map((value, idx) => (
            <div className="pillar-slot" key={value.title}>
              <article className="value-pillar">
                <div className="pillar-glass">
                  <div className="pillar-top">
                    <div className="pillar-icon">{value.icon}</div>
                    <div className="pillar-number">
                      {String(idx + 1).padStart(2, "0")}
                    </div>
                  </div>

                  <div className="pillar-content">
                    <h3>{value.title}</h3>
                    <div className="pillar-line" />
                    <p>{value.text}</p>
                  </div>

                  <div
                    className="pillar-image"
                    style={{ backgroundImage: `url(${value.image})` }}
                  >
                    <div className="pillar-image-overlay" />
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
